import React, { useState, useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { loadCategories, updateCategoryAds } from '../../Redux/Actions/ActionCategories';
import Select from 'react-select';
import Switch from "react-switch";

function EditCategoryAds({ arr, open, setOpen }) {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const categories = useSelector(state => state.Categories.categories)
    const [category, setCategory] = useState({ value: arr.category_id, label: arr.category_name });
    const [category_id, setcategory_id] = useState(arr.category_id)
    const [options, setoptions] = useState([])
    const [start_date, setstart_date] = useState(arr.start_date);
    const [end_date, setend_date] = useState(arr.end_date);
    const [priority, setpriority] = useState(arr.priority);
    const [url, seturl] = useState(arr.url);
    const [image, setimage] = useState('');
    const [is_active, setis_active] = useState(arr.is_active === 1 ? 1 : 0);
    const [loadBtn, setloabBtn] = useState(false);
    useEffect(() => {
        dispatch(loadCategories())
    }, [])
    useEffect(() => {
        if (categories.length > 0) {
            const updatedOptions = categories.map(category => ({
                value: category.id,
                label: category.name,
            }));
            setoptions(updatedOptions);
        }
    }, [categories])
    const setcategory_idd = (selectedOption) => {
        if (selectedOption) {
            const value = selectedOption.value;
            setcategory_id(value);
            setCategory(selectedOption)
        } else {
            setcategory_id(null);
            selectedOption(null)
        }
    }
    const activee = () => {
        setis_active(prevValue => (prevValue === 1 ? 0 : 1));
    };
    const FunSubmit = (e) => {
        dispatch(updateCategoryAds(arr.id,category_id, start_date, end_date, url, is_active, image, priority, setloabBtn))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center={false}
            classNames={{
                modal: "popAdd",
            }}
            focusTrapped={false}
        >
            <div className='popAddForm' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""}>{t('editcategoryAd')}</h3>
                <form>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('categories')}</span>
                            </div>
                            <Select
                                value={category}
                                onChange={setcategory_idd}
                                options={options}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused ? 'grey' : 'rgb(214, 214, 214)',
                                        borderRadius: "10px",
                                        margin: "0px 10px",
                                        width: "100%"
                                    }),
                                }}
                            />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('start_date')}</span>
                            </div>
                            <input defaultValue={start_date} type="date" placeholder={t('name_ar')} onChange={(e) => setstart_date(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('end_date')}</span>
                            </div>
                            <input defaultValue={end_date} type="date" placeholder={t('desc_en')} onChange={(e) => setend_date(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('priority')}</span>
                            </div>
                            <select value={priority} onChange={(e) => setpriority(e.target.value)} >
                                <option disabled="disabled" selected="selected">--Please choose an option--</option>
                                <option value='high' >high</option>
                                <option value='medium' >medium</option>
                                <option value='low' >low</option>
                            </select>
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('url')}</span>
                            </div>
                            <input defaultValue={url} type="text" onChange={(e) => seturl(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('image')}</span>
                            </div>
                            <input type="file" onChange={(e) => setimage(e.target.files[0])} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={is_active} onChange={activee} />
                        </div>
                    </div>
                </form>
                <div className='div_btn' ><button onClick={FunSubmit} >
                    {
                        loadBtn ? "Loading ... " : <>{t('addcategoryAd')}</>
                    }
                </button></div>
            </div>
        </RModal>
    )
}

export default EditCategoryAds